// extracted by mini-css-extract-plugin
export var container = "ResalesList-module--container--1d331";
export var core = "ResalesList-module--core--34027";
export var ctaWpp = "ResalesList-module--ctaWpp--a6073";
export var description = "ResalesList-module--description--bfb98";
export var location = "ResalesList-module--location--ea66a";
export var slide = "ResalesList-module--slide--bdd4d";
export var slider = "ResalesList-module--slider--39cbd";
export var text = "ResalesList-module--text--58575";